/* NATURFEUER Shop: Warenkorb-Schublade, Kaufleiste, Mengenwahl, Varianten */
(function () {
  var NF = window.NF || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart', root: '/', currency: 'EUR' };
  var fmt;
  try { fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: NF.currency || 'EUR' }); } catch (_) { fmt = { format: function (n) { return n.toFixed(2).replace('.', ',') + ' €'; } }; }
  function money(cents) { return fmt.format((cents || 0) / 100); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* Menge +/− */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b || b.closest('[data-cart-lines]')) return;
    var input = b.parentElement.querySelector('input[type="number"]');
    if (!input) return;
    var min = Number(input.min || 0);
    input.value = Math.max(min, Number(input.value || 0) + Number(b.getAttribute('data-qty')));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Varianten */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex], scope = sel.closest('section') || document;
      var price = scope.querySelector('[data-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;
      var btn = scope.querySelector('[data-buy-btn]');
      if (btn) {
        var ok = opt.dataset.available === 'true';
        btn.disabled = !ok;
        var label = btn.querySelector('span');
        if (label) label.textContent = ok ? 'In den Warenkorb' : 'Ausverkauft';
      }
    });
  });

  /* Warenkorb-Schublade */
  var drawer = document.getElementById('CartDrawer');
  var lines = drawer && drawer.querySelector('[data-cart-lines]');
  var foot = drawer && drawer.querySelector('[data-cart-foot]');
  var lastFocus = null;

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', !n); });
  }
  function render(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    foot.hidden = cart.item_count === 0;
    if (!cart.item_count) {
      lines.innerHTML = '<div class="drawer__empty"><p class="lead">Ihr Warenkorb ist leer.</p><a class="btn-ghost" href="' + esc(NF.root) + '">Solartisch ansehen</a></div>';
      return;
    }
    lines.innerHTML = '<ul class="drawer__lines">' + cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" width="120" height="90">' : '';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="note">' + esc(it.variant_title) + '</p>' : '';
      return '<li class="drawer__line">' +
        '<a class="drawer__img" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div class="drawer__info"><a class="drawer__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<p class="note">' + money(it.final_price) + ' pro Stück</p>' +
        '<div class="qty__ctl qty__ctl--sm"><button type="button" data-line="' + (i + 1) + '" data-set="' + (it.quantity - 1) + '" aria-label="Menge verringern">−</button>' +
        '<span class="qty__val" aria-label="Menge">' + it.quantity + '</span>' +
        '<button type="button" data-line="' + (i + 1) + '" data-set="' + (it.quantity + 1) + '" aria-label="Menge erhöhen">+</button></div></div>' +
        '<div class="drawer__end"><p class="drawer__sum">' + money(it.final_line_price) + '</p>' +
        '<button type="button" class="drawer__rm" data-line="' + (i + 1) + '" data-set="0">Entfernen</button></div></li>';
    }).join('') + '</ul>';
  }
  function fetchCart() { return fetch(NF.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function open() {
    if (!drawer) { location.href = NF.cart; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); drawer.querySelector('.drawer__panel').focus(); });
    document.body.classList.add('drawer-open');
  }
  function close() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    setTimeout(function () { drawer.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.querySelectorAll('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (!drawer || document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      fetchCart().then(render).then(open).catch(function () { location.href = NF.cart; });
    });
  });
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }
      var b = e.target.closest('[data-line]');
      if (!b) return;
      b.disabled = true;
      fetch(NF.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(b.dataset.line), quantity: Math.max(0, Number(b.dataset.set)) })
      }).then(function (r) { return r.json(); }).then(render).catch(function () { location.href = NF.cart; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* In den Warenkorb ohne Seitenwechsel */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ajax-add]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var now = !!(e.submitter && e.submitter.hasAttribute('data-buy-now'));
    var btn = e.submitter || form.querySelector('[type="submit"]'), err = form.querySelector('[data-add-error]');
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    if (err) err.hidden = true;
    fetch(NF.cartAdd + '.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (now) { location.href = (NF.root || '/').replace(/\/?$/, '/') + 'checkout'; return new Promise(function () {}); }
        return fetchCart().then(render).then(open);
      })
      .catch(function (j) {
        var msg = (j && j.description) || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.';
        if (err) { err.textContent = msg; err.hidden = false; }
        else if (btn) btn.title = msg;
      })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); } });
  });

  /* Kaufleiste einblenden, sobald der Kaufbereich aus dem Bild ist */
  var bar = document.querySelector('[data-buy-bar]'), heroBuy = document.querySelector('[data-hero-buy]');
  if (bar && heroBuy && 'IntersectionObserver' in window) {
    var past = false, nearEnd = false;
    function paint() {
      var show = past && !nearEnd;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
    }
    new IntersectionObserver(function (en) { past = !en[0].isIntersecting && en[0].boundingClientRect.top < 0; paint(); }).observe(heroBuy);
    var end = document.querySelector('.buy-band, .foot');
    if (end) new IntersectionObserver(function (en) { nearEnd = en[0].isIntersecting; paint(); }).observe(end);
  }

  /* Amortisationsrechnung */
  document.querySelectorAll('[data-amort]').forEach(function (box) {
    var price = parseFloat(box.getAttribute('data-price')) || 699, yld = parseFloat(box.getAttribute('data-yield')) || 375;
    var ip = box.querySelector('[data-i="p"]'), ie = box.querySelector('[data-i="e"]');
    var nf = function (n, d) { return n.toLocaleString('de-DE', { minimumFractionDigits: d, maximumFractionDigits: d }); };
    function calc() {
      var ct = Number(ip.value), share = Number(ie.value) / 100;
      var own = yld * share, eur = own * ct / 100, years = price / eur;
      box.querySelector('[data-o="p"]').textContent = ct + ' ct/kWh';
      box.querySelector('[data-o="e"]').textContent = Math.round(share * 100) + '\u00a0%';
      box.querySelector('[data-r="kwh"]').textContent = nf(own, 0) + '\u00a0kWh';
      box.querySelector('[data-r="eur"]').textContent = 'ca.\u00a0' + nf(eur, 0) + '\u00a0€';
      box.querySelector('[data-r="years"]').textContent = nf(years, 1);
    }
    ip.addEventListener('input', calc); ie.addEventListener('input', calc); calc();
  });

  /* Produktbilder (Produktseite mit Galerie) */
  var main = document.querySelector('[data-main-image]');
  document.querySelectorAll('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset'); main.src = t.getAttribute('data-thumb');
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); });
    });
  });

  /* Kontakt: Thema aus ?thema= vorauswählen */
  var topic = document.querySelector('[data-topic]');
  if (topic) {
    try {
      var want = new URLSearchParams(location.search).get('thema');
      if (want) Array.prototype.forEach.call(topic.options, function (o) { if (o.value.toLowerCase() === want.toLowerCase()) topic.value = o.value; });
    } catch (_) {}
  }
  var rec = document.querySelector('[data-recover]');
  if (rec) rec.addEventListener('click', function (e) { e.preventDefault(); var f = document.getElementById('recover'); if (f) f.scrollIntoView({ behavior: 'smooth' }); });
})();
